import { OwalPanelType } from '@/libraries/owal-ui/panels/OwalPanelType'

export const inputPanel = {
  props: {
    embedded: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      default: undefined,
    },
    type: {
      type: Number,
      default: function () {
        return OwalPanelType.INPUT
      },
    },
  },
  data () {
    return {
      submission: {
        type: Object,
        default: undefined,
      },
      identifier: {
        type: String,
        default: function () {
          if (this.content && this.content.form) {
            return this.content.form.identifier
          }
          throw new Error('Adopters of the inputPanel mixin must provide an identifier if they do not use a form for input. (i.e. If they use a custom component instead.)')
        },
      },
    }
  },
  methods: {
    inputChange: function (identifier, value) {
      this.submission.setValueForField(identifier, value)
      this.$emit('inputChange', this.submission)
    },
  },
}
